module.exports = __webpack_public_path__ + "img/yy1_mb.d4ba0d65.jpg";